import type { ApplicantCard } from '@/hooks/use-opportunity-applicants'
import { matchBand, MATCH_BANDS, type MatchBand } from '@/lib/match-bands'

export type MatchBandCounts = Record<MatchBand, number>

export function applicantsHaveMatchScores(applicants: ApplicantCard[]): boolean {
  return applicants.some((applicant) => applicant.match_score != null)
}

export function applicantsByProfileId(applicants: ApplicantCard[]): Record<string, ApplicantCard> {
  const byId: Record<string, ApplicantCard> = {}
  for (const applicant of applicants) {
    byId[applicant.profile.id] = applicant
  }
  return byId
}

export function matchBandCountsFromApplicants(applicants: ApplicantCard[]): MatchBandCounts {
  const counts = Object.fromEntries(MATCH_BANDS.map((band) => [band, 0])) as MatchBandCounts
  for (const applicant of applicants) {
    if (typeof applicant.match_score !== 'number') continue
    counts[matchBand(applicant.match_score)] += 1
  }
  return counts
}
